export default __webpack_public_path__ + "static/media/User-Error.8f19a6e7.svg";